import http from './index'
//注册
export const index_freeTrial = function (data) {
  return http(`/index/OnlinePayment/freeTrial`, data, 'post')
}



// WEBPACK FOOTER //
// ./src/csconfig/api.js